"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrichAIDashboardContainer = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const dashboard_content_component_1 = require("./dashboard-content.component");
const enrich_ai_dashboard_styles_1 = require("./enrich-ai-dashboard.styles");
const hlqa_tasks_widget_1 = require("./hlqa-tasks-widget");
const hooks_1 = require("../client/hooks");
const enrich_ai_settings_widget_1 = require("../enrich-ai-settings-widget");
const enrich_ai_styles_1 = require("../enrich-ai.styles");
const feature_flags_1 = require("../../feature-flags");
const hooks_2 = require("../../hooks");
const localization_1 = require("../../localization");
const router_1 = require("../../router");
const store_1 = require("../../store");
const EnrichAIDashboardContainer = () => {
    var _a;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { clearStore } = (0, hooks_1.useClearStore)();
    const { featureFlagsService } = (0, hooks_2.useFeatureFlagsService)();
    const isDashboardContentEnabled = (_a = featureFlagsService === null || featureFlagsService === void 0 ? void 0 : featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.DashboardContent)) !== null && _a !== void 0 ? _a : false;
    const selectedProjectId = (0, store_1.useSelectedProjectId)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const selectedCatalogProductsTreeId = (0, store_1.useProductTreeId)();
    const onSelectCatalog = (0, react_1.useCallback)((catalog) => dispatch((0, store_1.enrichAISetSelectedCatalog)(catalog)), [dispatch]);
    const onSelectProject = (0, react_1.useCallback)((project) => dispatch((0, store_1.enrichAISetSelectedProject)(project)), [dispatch]);
    const productTreeRootNodeId = (0, store_1.useProductTreeRootNodeId)();
    const handleSelectCatalogId = (catalogId) => __awaiter(void 0, void 0, void 0, function* () {
        yield clearStore();
        onSelectCatalog({ id: catalogId });
    });
    const handleSelectProject = (project) => __awaiter(void 0, void 0, void 0, function* () {
        yield clearStore();
        onSelectProject({
            id: project.id,
            slug: project.slug,
        });
    });
    return (react_1.default.createElement(enrich_ai_styles_1.StyledPageContainer, { className: isDashboardContentEnabled ? 'dashboard' : 'dashboard dashboard-hlqa-only' }, react_1.default.createElement(ui_components_1.PageTitle, { className: "title", title: t({ key: 'ENRICH_OVERVIEW' }), buttons: react_1.default.createElement(react_router_dom_1.Link, { to: router_1.EnrichSection.Workspace }, react_1.default.createElement(ui_components_1.Button, { color: "primary", rounded: true, variant: "contained" }, t({ key: 'GO_TO_WORKSPACE' }))) }), react_1.default.createElement(enrich_ai_dashboard_styles_1.StyledSelectorsWrapper, null, react_1.default.createElement(enrich_ai_settings_widget_1.EnrichAISettingsSelectors, { selectedProjectId: selectedProjectId, selectedCatalogId: selectedCatalogId, onSelectProject: handleSelectProject, onSelectCatalogId: handleSelectCatalogId, withLabels: false })), isDashboardContentEnabled && (react_1.default.createElement(dashboard_content_component_1.DashboardContent, { selectedCatalogId: selectedCatalogId, selectedCatalogProductsTreeId: selectedCatalogProductsTreeId, productTreeRootNodeId: productTreeRootNodeId })), react_1.default.createElement(hlqa_tasks_widget_1.HLQATasksWidget, null)));
};
exports.EnrichAIDashboardContainer = EnrichAIDashboardContainer;
exports.default = exports.EnrichAIDashboardContainer;
